<my-head></my-head><template>

    <div class="about-div">
      <div class="product-box">
        <div class="about-title text-left">公司简介</div>
        <div class="about-text">
          广州勇往科技成立于2016年，致力于为用户打造一个顶级的娱乐平台，公司于2018年4月获得顶级投资机构金沙江创投的A轮投资。截止目前，公司已为8000万用户提供服务，成为微信小程序领域的顶级开发商。
        </div>
      </div>
      <div class="row clearfix product-box" style="margin: 0 auto">
        <div class="about-title text-left" style="margin-bottom: 20px">发展历程</div>
        <div class="develop-box">
          <div class="develop-time">
            <span>2016</span>
            <span>9月</span>
          </div>
          <div class="develop-icon"><img src="../assets/images/1.png" class="img-responsive" alt="Responsive image">
          </div>
          <div class="develop-text">
            <p>勇往科技<span class="blue">在广州成立</span></p>
            <p>获数百万融资</p>
            <p>荣获广州市首届「海创会」创业大赛二等奖</p>
          </div>
        </div>
        <div class="develop-box">
          <div class="develop-time">
            <span>2017</span>
            <span>5月</span>
          </div>
          <div class="develop-icon"><img src="../assets/images/2.png" class="img-responsive" alt="Responsive image">
          </div>
          <div class="develop-text">
            <p><span class="blue">【画画猜猜】和【猜歌达人】</span></p>
            <p>小程序正式上线</p>
          </div>
        </div>
        <div class="develop-box">
          <div class="develop-time">
            <span>2017</span>
            <span>7月</span>
          </div>
          <div class="develop-icon"><img src="../assets/images/3.png" class="img-responsive" alt="Responsive image">
          </div>
          <div class="develop-text">
            <p>获得飞马资本,数百万元<span class="blue"> Pre-A </span>轮融资</p>
          </div>
        </div>
        <div class="develop-box">
          <div class="develop-time">
            <span>2017</span>
            <span>8月</span>
          </div>
          <div class="develop-icon"><img src="../assets/images/4.png" class="img-responsive" alt="Responsive image">
          </div>
          <div class="develop-text">
            <p>【画画猜猜】日活人数突破<span class="blue"> 100万人</span></p>
          </div>
        </div>
        <div class="develop-box">
          <div class="develop-time">
            <span>2017</span>
            <span>10月</span>
          </div>
          <div class="develop-icon"><img src="../assets/images/5.png" class="img-responsive" alt="Responsive image">
          </div>
          <div class="develop-text">
            <p>荣获阿拉丁神灯奬</p>
            <p>成为<span class="blue"> 全国 Top 100 </span>小程序开发商</p>
          </div>
        </div>
        <div class="develop-box">
          <div class="develop-time">
            <span>2017</span>
            <span>12月</span>
          </div>
          <div class="develop-icon"><img src="../assets/images/6.png" class="img-responsive" alt="Responsive image">
          </div>
          <div class="develop-text">
            <p>猜歌达人日活人数<span class="blue"> 突破 300万人 </span></p>
            <p>登上阿拉丁小程序排行榜TOP3</p>
          </div>
        </div>
        <div class="develop-box">
          <div class="develop-time">
            <span>2018</span>
            <span>2月</span>
          </div>
          <div class="develop-icon"><img src="../assets/images/7.png" class="img-responsive" alt="Responsive image">
          </div>
          <div class="develop-text">
            <p>累计总用户突破<span class="blue">6500万</span></p>
          </div>
        </div>
        <div class="develop-box">
          <div class="develop-time">
            <span>2018</span>
            <span>3月</span>
          </div>
          <div class="develop-icon"><img src="../assets/images/8.png" class="img-responsive" alt="Responsive image">
          </div>
          <div class="develop-text">
            <p>成为全国<span class="blue"> Top 3 </span>小程序开发商</p>
            <p>获金沙江创投千万元融资</p>
          </div>
        </div>
      </div>
      <div class="about-div">
        <div class="product-box">
          <div class="about-title text-left">小程序 TOP5企业</div>
          <div class="about-img"><img src="../assets/images/top5.png" style="margin:30px 0 20px">
            <p>数据来源(阿拉丁小程序统计平台)</p></div>
        </div>
      </div>
    </div>

</template>

<script>


  export default {
    name: "about_company",
    components: {
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/about_company.vue